import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { routeMap, SUPPORTED_LANGS } from '../routes/routeMap';

/**
 * Hook that returns the current language and a switchLanguage(newLng) function.
 * On switch it finds the equivalent path in the new language and navigates.
 */
export function useLanguageSwitcher() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const switchLanguage = (newLng) => {
    const currentLng = i18n.language;
    // Strip language prefix to get the bare path
    const pathWithoutLng = location.pathname.replace(new RegExp(`^/${currentLng}`), '') || '/';

    // Find matching route entry for current path
    const routeEntry = Object.entries(routeMap).find(
      ([, paths]) => paths[currentLng] === pathWithoutLng
    );

    const newPath = routeEntry
      ? `/${newLng}${routeEntry[1][newLng]}`
      : `/${newLng}${pathWithoutLng}`; // fallback: keep same slug

    localStorage.setItem('fm_lang', newLng);
    i18n.changeLanguage(newLng);
    navigate(newPath, { replace: true });
  };

  return { currentLang: i18n.language, switchLanguage, supportedLangs: SUPPORTED_LANGS };
}
